export enum RooferImageType {
  Profile = 'ROOFER_PROFILE',
  CompanyLogo = 'ROOFER_LOGO',
}
